<!-- INPUT TYPE TEXT, ETC... ALL SIZES -->
<div *ngIf="!autoComplete && !disabled && type != 'password' && type != 'number' && size == ''" [id]="'cnt_' + inputId" class="ti-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != '' && !hideLabel" class="ti-label" [ngClass]="{'ti-span-error' : isRequired && !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <input [id]="inputId" [type]="type" class="ti-input" [placeholder]="placeHolder" (keyup)="onKeyUpChange($event)" (input)="onInputChange($event)" (focus)="onInputFocus($event)" (keydown)="onKeyDown($event)"
        [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': readOnly}" [value]="value" [readonly]="readOnly" [attr.maxlength]="maxLength">
</div>

<!-- INPUT TYPE TEXT, ETC... SMALL SIZES -->
<div *ngIf="!autoComplete &&!disabled && type != 'password' && type != 'number' && size == 's'" [id]="'cnt_' + inputId"  class="ti-cnt ti-cnt-small" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != '' && !hideLabel" class="ti-label" [ngClass]="{'ti-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <input [id]="inputId" [type]="type" class="ti-input ti-input-small" [placeholder]="placeHolder" (keyup)="onKeyUpChange($event)" (input)="onInputChange($event)" (focus)="onInputFocus($event)" 
    (keydown)="onKeyDown($event)"
    [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': readOnly}" [value]="value" [readonly]="readOnly" [attr.maxlength]="maxLength">
</div>

<!-- INPUT TYPE NUMBER... ALL SIZES-->
<div *ngIf="!autoComplete && !disabled && type == 'number' && size == ''" [id]="'cnt_' + inputId" class="ti-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != '' && !hideLabel" class="ti-label" [ngClass]="{'ti-span-error' : isRequired && !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div class="input-wrapper">
        <div *ngIf="startIcon" class="prefix">
            <i class="{{startIcon}}"></i>
        </div>
        <input [id]="inputId" [type]="'text'" class="ti-input" [placeholder]="placeHolder" (keyup)="onKeyUpChange($event)"
            (input)="onNumericInputChange($event)" (focus)="onInputFocus($event)" (focusout)="onNumericFocusOut($event)" (keydown)="onKeyDown($event)"
            [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': readOnly}"
            [value]="getNumericDisplayValue(value)" [readonly]="readOnly" min="0.1">
    </div>
</div>

<!-- INPUT TYPE NUMBER... SMALL SIZES-->
<div *ngIf="!autoComplete && !disabled && type == 'number' && size == 's'" [id]="'cnt_' + inputId" class="ti-cnt ti-cnt-small" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != '' && !hideLabel && !isMultiOperator" class="ti-label" [ngClass]="{'ti-span-error' : isRequired && !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div *ngIf="isMultiOperator" class="tdt-query-cnt">
        <!-- BEFORE -->
        <div *ngIf="selQueryDirection != 'lt'" class="tdt-ico-direction" (click)="onSelectDirection('lt')" [title]="'grid.dateBefore' | translate">
            <i class="fal fa-chevron-left tdt-ico-query"></i>
        </div>
        <!-- BEFORE SELECTED -->
        <div *ngIf="selQueryDirection == 'lt'" class="tdt-ico-direction-selected">
            <i  class="fal fa-chevron-left tdt-ico-query"></i>
        </div>
        
        <!-- EQUALS -->
        <div *ngIf="selQueryDirection != 'eq'" class="tdt-ico-direction" (click)="onSelectDirection('eq')" [title]="'grid.dateEquals' | translate">
            <i class="fal fa-equals tdt-ico-query" ></i>
        </div>
        <!-- EQUALS SELECTED -->
        <div *ngIf="selQueryDirection == 'eq'" class="tdt-ico-direction-selected">
            <i class="fal fa-equals tdt-ico-query"></i>
        </div>
    
        <!-- AFTER -->
        <div *ngIf="selQueryDirection != 'gt'" class="tdt-ico-direction"  (click)="onSelectDirection('gt')" [title]="'grid.dateAfter' | translate">
            <i class="fal fa-chevron-right tdt-ico-query"></i>
        </div>
        <!-- AFTER SELECTED -->
        <div *ngIf="selQueryDirection == 'gt'" class="tdt-ico-direction-selected">
            <i class="fal fa-chevron-right tdt-ico-query"></i>
        </div>

        <!-- BETWEEN -->
         <div *ngIf="selQueryDirection != 'ltgt'" class="tdt-ico-direction"  (click)="onSelectDirection('ltgt')" [title]="'grid.between' | translate">
            <i class="fal fa-arrows-alt-h tdt-ico-query"></i>
        </div>
        <!-- BETWEEN SELECTED -->
        <div *ngIf="selQueryDirection == 'ltgt'" class="tdt-ico-direction-selected">
            <i class="fal fa-arrows-alt-h tdt-ico-query"></i>
        </div>
    
        <!-- CLEAR -->
        <div *ngIf="selQueryDirection != ''" class="tdt-ico-direction" (click)="onClearDirection()" [title]="'grid.clearDirection' | translate">
            <i class="fal fa-times tdt-ico-query"></i>
        </div>  
        <div *ngIf="selQueryDirection == ''" class="tdt-ico-direction-disabled">
            <i class="fal fa-times tdt-ico-query"></i>
        </div>  
    </div>
    <div class="input-wrapper">
        <div *ngIf="startIcon" class="prefix">
            <i class="{{startIcon}}"></i> 
        </div>
        <input *ngIf="!isMultiOperator" [id]="inputId" [type]="'text'" class="ti-input ti-input-small" [placeholder]="placeHolder"
            (keyup)="onKeyUpChange($event)" (input)="onNumericInputChange($event)" (focus)="onInputFocus($event)"
            (keydown)="onKeyDown($event)"
            [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': readOnly}"
            [value]="getNumericDisplayValue(value)" [readonly]="readOnly" step="any" min="0.1">

        <input *ngIf="isMultiOperator && (selQueryDirection == '' || selQueryDirection == 'lt' || selQueryDirection == 'gt' || selQueryDirection == 'eq')" [id]="inputId" [type]="'text'" class="ti-input ti-input-small" [placeholder]="placeHolder"
            (keyup)="onKeyUpChange($event)" (input)="onNumericInputChange($event)" (focus)="onInputFocus($event)"
            (keydown)="onKeyDown($event)"
            [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': false}"
            [value]="getNumericDisplayValue(value)" [readonly]="readOnly" step="any" min="0.1">

        <input *ngIf="isMultiOperator && selQueryDirection == 'ltgt'" [type]="'text'" class="ti-input ti-input-small mr-5" [placeholder]="placeHolder"
            (input)="onBetweenNumberChange($event, true)" (focus)="onInputFocus($event)"
            [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': false}"
            [value]="getNumericDisplayValue(value1)" [readonly]="readOnly" step="any" min="0.1">

        <input *ngIf="isMultiOperator && selQueryDirection == 'ltgt'" [id]="inputId" [type]="'text'" class="ti-input ti-input-small ml-5" [placeholder]="placeHolder"
            (input)="onBetweenNumberChange($event, false)" (focus)="onInputFocus($event)"
            [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile, 'ti-readonly': false}"
            [value]="getNumericDisplayValue(value2)" [readonly]="readOnly" step="any" min="0.1">

        <!-- UOMS -->
        <teiasoft-select *ngIf="hasUoms" [size]="'s'" [filterVersion]="true" [optionsList]="uomOptionList" 
            [defaultValue]="selectedUom"
            (onSelected)="onSelectedUom($event)" [clearValue]="clearValue"
            style="min-width:1.5vw; width:9vw; margin-left:0.2vw"></teiasoft-select>
    </div>
</div>

<!-- INPUT TYPE PASSWORD ALL SIZES-->
<div *ngIf="!disabled && type == 'password'" class="ti-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != '' && !hideLabel" class="ti-label" [ngClass]="{'ti-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div id="inputPwdCnt" class="ti-pwd-cnt">
        <input id="inputPwd" [type]="myType" id="inputPwd" class="ti-input-pwd" [placeholder]="placeHolder" (keyup)="onKeyUpChange($event)" (input)="onInputChange($event)" (keydown)="onKeyDown($event)"
        [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-pwd-mobile' : isMobile, 'ti-readonly': readOnly}" [value]="value" [readonly]="readOnly">
        <span *ngIf="myType == 'password'" class="ico-eye" (click)="myType = 'text'" [ngClass]="{'ico-eye-mobile' : isMobile}" >&#63;</span>
        <span *ngIf="myType == 'text'" class="ico-eye" (click)="myType = 'password'" [ngClass]="{'ico-eye-mobile' : isMobile}" >&#10007;</span>
    </div>
</div>

<!-- ALL INPUT DISABLED ALL SIZES-->
<div *ngIf="disabled" class="ti-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != '' && !hideLabel" class="ti-label"  [ngClass]="{'ti-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div class="input-wrapper">
        <div *ngIf="startIcon" class="prefix">
            <i class="{{startIcon}}"></i>
        </div>
        <input [id]="inputId" [type]="'text'" class="ti-input ti-input-disabled"
            [ngClass]="{'ti-input-error' : isRequired && !isValid}" [placeholder]="placeHolder" [value]="getValueWithRoudDigits(value)" readonly
            [ngClass]="{'ti-input-mobile' : isMobile}">
    </div>
</div>

<!-- INPUT TYPE AUTOCOMPLETE (click)="onAutocompleteIcoClick($event)"  -->
<div #inputWrapper *ngIf="autoComplete && !disabled && type != 'password' && size == ''" [id]="'cnt_' + inputId" class="ti-cnt" [attr.tabindex]="preserveFocusOnAutocompleteSelection ? -1 : null" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}"
    (click)="onAutocompleteIcoClick($event)">
    <span *ngIf="labelText != '' && !hideLabel" class="ti-label" [ngClass]="{'ti-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div class="ti-chips-cnt" [style.height.vh]="chipsContainerViewHeight" [ngClass]="{'ti-readonly': readOnly}"  
        [ngStyle]="{'cursor': readOnly ? 'default' : 'pointer'}">
        <div class="ti-chips-wrapper" [ngClass]="{'ti-readonly': readOnly}">
            <teiasoft-chips [values]="value" [value]="value"
                [readOnly]="readOnly" [multiSelection]="multiSelection" [allowSingleSelectionClear]="allowSingleSelectionClear"
                style="width: calc(100% - 2.4vw);" (deleteValue)="deleteValue($event)"></teiasoft-chips>
        </div>
        <button *ngIf="!readOnly" class="ti-ico-cnt" (focus)="onMultiSelectionFocus($event)">
            <i *ngIf="!imOpen() && !multiSelection" class="fal fa-angle-down ts-ico" [ngClass]="{'ts-ico-disabled' : disabled || readOnly}"></i>
            <i *ngIf="imOpen() && !multiSelection" class="fal fa-angle-up ts-ico" [ngClass]="{'ts-ico-disabled' : disabled || readOnly}"></i>
            <i *ngIf="!imOpen() && multiSelection" class="fal fa-crosshairs ts-ico" [ngClass]="{'ts-ico-disabled' : disabled || readOnly}"></i>
            <i *ngIf="imOpen() && multiSelection" class="fal fa-times-circle ts-ico" [ngClass]="{'ts-ico-disabled' : disabled || readOnly}"></i>
        </button>
    </div>
</div>


<!-- AUTOCOMPLETE GRID [style.width.px]="cntGridW"-->
<div [id]="autoCompleteId" *ngIf="autoComplete" class="ti-autocomplete-cnt" [ngClass]="{'anchor-right': anchor == 'right'}" [ngStyle]="{'position': autoCompletePosition}" [style.width.px]="optionsW" [style.top.px]="optionsTop" [style.left.px]="optionsLeft">
    <div class="autocomplete-menu" >
        <input *ngIf="!readOnly" [id]="inputId" [type]="type" class="ti-input-ac" [placeholder]="placeHolder" (keyup)="onKeyUpChange($event)" 
        (input)="onInputChange($event)" (focus)="onInputFocus($event)" (focusout)="onInputFocusOut($event)" (keydown)="onKeyDown($event)"
        [ngClass]="{'ti-input-error' : isRequired && !isValid, 'ti-input-mobile' : isMobile}" [style.width.%]="75" autocomplete="off">
        <div *ngIf="showCreate" class="autocomplete-link-cnt">
            <teiasoft-link [text]="'enquiryBook.createDummy' | translate" (onClick)="onClickLink('create|dummy')" style="margin-right: 0.5vw;"></teiasoft-link>
            <!-- <teiasoft-link [text]="'commons.close' | translate" (onClick)="onClickLink('')"></teiasoft-link> -->
        </div>
    </div>
    <!-- AUTOCOMPLETE HEADER - ONLY FOR MULTISELECTION *ngIf="autoComplete && multiSelection"-->
    <div *ngIf="autoCompleteDataset && autoCompleteDataset.length > 0" class="ac-header" [style.width.px]="optionsW">
        <div *ngFor="let col of acColumns;trackBy: trackByIndex" class="ac-header-cell" [style.width.%]="getColumnsWidth(col, 'h')">
            <span class="span-header">{{'autoComplete.' + col | translate}}</span>
        </div>
    </div>
    <!-- AUTOCOMPLETE ROWS VALUES -->
    <div *ngIf="autoCompleteDataset && autoCompleteDataset.length > 0" class="ac-rows-cnt" [id]="'ac_cnt_' + autoCompleteId">
        <div *ngFor="let item of autoCompleteDataset; let i=index; trackBy: trackByIndex" [id]="'ac_row_' + autoCompleteId + '_' + i" class="ac-row" (mousedown)="onAutocompleteRowMouseDown($event)" (click)="rowClick($event, item, true)" [ngClass]="{'ac-row-selected': (isRowSelected(item)) }"><!--  || hoverIndex == i -->
            <div *ngFor="let key of acColumns;trackBy: trackByIndex" class="ac-cell" [style.width.%]="getColumnsWidth(key,'r')">
                <!-- <span class="ac-cell-span">{{getColValue(item, key)}}</span> -->
                <span *ngIf="getValueType(item, key) !== 'boolean'" class="ac-cell-span" [title]="getColValue(item, key)">{{getColValue(item, key)}}</span>
                <i *ngIf="getValueType(item, key) === 'boolean' && item[key] == true" class="fal fa-check-circle green"></i>
            </div>
        </div>
    </div>
</div>
